// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1ylhY","right":"Footer_right__KRcjZ","buttons":"Footer_buttons__1eHm7"};